module.exports = __webpack_public_path__ + "static/media/bentley.938ac631.png";